import {createContext as $95phC$createContext} from "react";

/*
 * Copyright 2024 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the 'License');
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an 'AS IS' BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 
const $4e85f108e88277b8$export$b085522c77523c51 = (0, $95phC$createContext)(null);
const $4e85f108e88277b8$export$ebe63fadcdce34ed = (0, $95phC$createContext)(null);
const $4e85f108e88277b8$export$44644b8a16031b5b = (0, $95phC$createContext)(null);
const $4e85f108e88277b8$export$717b2c0a523a0b53 = (0, $95phC$createContext)(null);
const $4e85f108e88277b8$export$265015d6dc85bf21 = (0, $95phC$createContext)(null);
const $4e85f108e88277b8$export$d688439359537581 = (0, $95phC$createContext)({});


export {$4e85f108e88277b8$export$b085522c77523c51 as CheckboxContext, $4e85f108e88277b8$export$ebe63fadcdce34ed as ColorAreaContext, $4e85f108e88277b8$export$44644b8a16031b5b as ColorFieldContext, $4e85f108e88277b8$export$717b2c0a523a0b53 as ColorSliderContext, $4e85f108e88277b8$export$265015d6dc85bf21 as ColorWheelContext, $4e85f108e88277b8$export$d688439359537581 as HeadingContext};
//# sourceMappingURL=RSPContexts.module.js.map
